export default "__VITE_ASSET__Dvn7O7Qs__"